// lib
import React from "react";
import PropTypes from "prop-types";
import { Group, LibraryBooks, Person, Room } from "@material-ui/icons";
// src
import { ResourceType } from "config/constants";

// We may type preset in difference case:
// - if is a permanent with only one kind of params
// - if a resource preset (only one kind of params by definition)
// - if is a permanent preset with an explicit option
const ResourceIcon = ({ preset }) => {
  const { resourceType } = preset;
  if (resourceType) {
    if (resourceType === ResourceType.COURSE) return <LibraryBooks className="icon-type" />;
    if (resourceType === ResourceType.GROUP) return <Group className="icon-type" />;
    if (resourceType === ResourceType.ROOM) return <Room className="icon-type" />;
    if (resourceType === ResourceType.PERSON) return <Person className="icon-type" />;
  }
  return null;
};

ResourceIcon.propTypes = {
  preset: PropTypes.object.isRequired,
};

export default ResourceIcon;
